import React from 'react';
import { List } from 'antd';

function UserList({
  users,
  idPrefix,
}) {
  return (
    <List
      id={`${idPrefix}_user_list`}
      prefixCls="modal_user_list ant-list"
      dataSource={users}
      rowKey="userId"
      renderItem={(item) => (
        <li>{item.name}</li>
      )}
    />
  );
}

export default UserList;
